import Transformer from '@/transformers/transformer'

export default class familyTransformer extends Transformer {
  static fetch(family) {
    return {
      id: family.id,
      name: family.name,
      codename: family.codename,
      slug: family.slug
    }
  }

  static send(family) {
    return {
      name: family.name,
      codename: family.codename
    }
  }
}
